import moduleHelp from '@/moduleHelp'

const state = {
    /**
     * ヘルプの表示有無
     */
    showHelp:false,
    /**
     * ヘルプのタイトル
     */
    helpTitle:null,
    /**
     * ヘルプの本文
     */
    helpText:null,
    /**
     * ヘルプの参照部分のタイトル
     */
    referenceTitle:null,
    /**
     * ヘルプの参照部分の本文
     */
    referenceText:null,
}

const getters = {
    /**
     * ヘルプの表示可否を返す
     * @param {Object} state 
     */
    getShowHelp(state){
        return state.showHelp
    },
    /**
     * ヘルプの題名を返す
     * @param {Object} state 
     */
    getHelpTitle(state){
        return state.helpTitle
    },
    /**
     * ヘルプの本文を返す
     * @param {Object} state 
     */
    getHelpText(state){
        return state.helpText
    },
    /**
     * ヘルプの参照部分の題名を返す
     * @param {Object} state 
     */
    getReferenceTitle(state){
        return state.referenceTitle
    },
    /**
     * ヘルプの参照部分の本文を返す
     * @param {Object} state 
     */
    getReferenceText(state){
        return state.referenceText
    },
}

const actions = {
    /**
     * クリックされたヘルプのキーをもとにmoduleHelpからヘルプの本文を取得する
     * @param {String} name 
     */
    setHelp ({commit}, name) {
        let helpData = {}
        if(moduleHelp[name] != undefined && moduleHelp[name].reference) {
            helpData = {
                helpTitle: moduleHelp[name].title,
                helpText: moduleHelp[name].text,
                referenceTitle: moduleHelp[name].reference.title,
                referenceText: moduleHelp[name].reference.text
            }
        } else if (moduleHelp[name] != undefined) {
            helpData = {
                helpTitle: moduleHelp[name].title,
                helpText: moduleHelp[name].text,
                referenceTitle:null,
                referenceText: null
            }
        } else {
            helpData = {
                helpTitle: '未実装です(' + name + ')' ,
                helpText: null,
                referenceTitle: null,
                referenceText: null
            }
        }
        commit('setHelp', helpData)
    },
    /**
     * ヘルプの表示状況を変更する
     */
    changeHelp({commit}) {
        commit('changeHelp')
    }
}
const mutations =  {
    /**
     * 取得されたヘルプの本文をstateに格納する
     * @param {Object} state
     * @param {Object} object(ヘルプの内容) 
     */
    setHelp(state, {helpTitle, helpText, referenceTitle, referenceText}) {
        state.helpTitle = helpTitle
        state.helpText = helpText
        state.referenceTitle = referenceTitle
        state.referenceText = referenceText       
    },
    /**
     * ヘルプの表示状況を変更する
     */
    changeHelp(state) {
        state.showHelp = !state.showHelp
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}